import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class ResubmitAssignmentMutation {
  constructor(mutationProps, callbacks) {
    this.props = mutationProps;

    const query = this.getQuery();
    const variables = this.getVariables();

    this.graphqlMutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);
  }

  getQuery() {
    return Relay.QL`
        mutation resubmitAssignmentMutation($input_0: ResubmitAssignmentInput!, $userId: String) {
          resubmitAssignment(input: $input_0) {
            course {
              coursePerformance(userId: $userId) {
                progressMeasure
                scaledProgressMeasure
                completionStatus
                successStatus
                complete
              }
            }
            card {
              performance(userId: $userId) {
                completionStatus
                successStatus
                progressMeasure
                scaledProgressMeasure
                actualSubmit
                successStatus
                forceComplete
              }
              questionAnswers(userId: $userId) {
                id
                pid
                q
                rType
                rTypeSecondary
                rawScore
                correctAnswerFeedback
                incorrectAnswerFeedback
                actualSubmit
                minScore
                maxScore
                gradingScheme
                contributeToCompleteStatus
                peerQuestions(userId: $userId) {
                  question
                  reviewsReceived {
                    reviewedBy {
                      pid
                    }
                  }
                }
                opinionType
                options{
                  text
                  correct
                }
                topRatedResponses {
                  answer {
                    response
                    answerType
                  }
                  user {
                    name
                    picture
                  }
                }
                answer {
                  id
                  pid
                  response
                  answerType
                  evaluatedAnswer
                  feedback
                  thumbUrl
                  lastUpdatedResponse
                  feedbacks {
                    feedback
                    feedbackGivenBy {
                      pid
                      name
                      picture
                    }
                  }
                  gradedBy {
                    pid
                    name
                    picture
                  }
                  feedbackGivenBy {
                    pid
                    name
                    picture
                  }
                }
                options {
                  text
                  correct
                }
                pairs {
                  id
                  left {
                    id
                    text
                  }
                  right {
                    id
                    text
                  }
                }
                ftbComponents {
                  id
                  text
                  isBlank
                }
                globalDistractors {
                  id
                  text
                }
              }
            }
            clientMutationId
          }
        }
      `;
  }

  getVariables() {
    return {
      input: {
        rootOfferId: this.props.rootOfferId,
        assignmentCardId: this.props.assignmentCardId,
        userId: this.props.userId,
        timeStamp: new Date().toISOString()
      },
      userId: this.props.userId
    };
  }

  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          course: this.props.courseRelayId,
          card: this.props.cardRelayId
        }
      }
    ];
  }

  commit() {
    this.graphqlMutation.commit(this.getConfigs());
  }
}
